import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Contact } from '../entity/contact';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { BLService } from './bl.service';

@Injectable()
export class ContactService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'contact';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  saveContact(clientId: number, contact: Contact): Observable<Contact> {
    if (contact.id) {
      return this.updateContact(contact);
    }
    return this.createContact(clientId, contact);
  }

  deleteContact(id: number): Observable<boolean> {
    const url = `${this.url}/${id}`;
    return this.http
      .delete<boolean>(url, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  private createContact(clientId: number, contact: Omit<Contact, 'id' | 'clientId'>): Observable<Contact> {
    const body = JSON.stringify(contact);
    return this.http
      .post<Contact>(`${this.url}/${clientId}`, body, this.options.getAuthorizationHeader())
      .pipe(this.catchErrorAndShowMessage());
  }

  private updateContact(contact: Contact): Observable<Contact> {
    const body = JSON.stringify(contact);
    return this.http
      .put<Contact>(`${this.url}`, body, this.options.getAuthorizationHeader())
      .pipe(this.catchErrorAndShowMessage());
  }
}
